<div class="transaction-details-container">
  <div class="header">
    <span>Track and manage all your financial transactions. Monitor payments, transfers, and account activities with detailed insights and real-time updates.</span>
    <div class="actions">
      <div class="search-input-container">
        <i class="fa-solid fa-magnifying-glass" style="opacity: 0.9; color: #289DD2;"></i>
        <input type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearchChange()" placeholder="Search transactions..."
          class="search-input" />
        <i *ngIf="searchQuery" class="fa-solid fa-xmark clear-search"
          style="opacity: 0.8; cursor: pointer; color: #289DD2; margin-left: 5px;"
          (click)="searchQuery = ''; onSearchChange()"></i>
      </div>
    </div>
  </div>
  
  <div class="table-container">
    <table class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-hashtag th-icon"></i>
              <span>Transaction ID</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-days th-icon"></i>
              <span>Date & Time</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-building th-icon"></i>
              <span>From/To</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-dollar-sign th-icon"></i>
              <span>Amount</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-circle-info th-icon"></i>
              <span>Status</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-gears th-icon"></i>
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="filteredTransactions.length > 0; else noTransactions">
          <tr *ngFor="let transaction of filteredTransactions">
            <td class="transaction-id" style="font-weight: 500;">{{ transaction.subscription_id }}</td>
            <td style="opacity: 0.9; font-size: 14px;">
              {{ transaction.created | date: 'MMM dd, yyyy' }}<br>
              <span style="font-size: 12px; opacity: 0.7;">{{ transaction.dateTime | date: 'HH:mm:ss' }}</span>
            </td>
            <!-- <td>{{ transaction.type }}</td> -->
            <td>{{ transaction.payment_method }}</td>
            <td [ngClass]="getAmountClass(transaction.amount)">{{ formatAmount(transaction.amount) }}</td>
            <td>
              <span class="status-badge" [ngClass]="getStatusClass(transaction.status)">{{ transaction.status }}</span>
            </td>
            <!-- <td>{{ transaction.description }}</td> -->
            <td class="h-[55px]">
              <button
                    *ngIf="transaction.status !== 'Failed' && transaction.invoice_url"
                    class="action-button"
                    (click)="viewTransactionDetails(transaction)">
                    View Invoice
            </button>
              <button
                *ngIf="transaction.status === 'Failed'"
                class="action-button retry-button"
                (click)="retryPayment(transaction)">
                Retry Payment
              </button>
            </td>
          </tr>
        </ng-container>
        <ng-template #noTransactions>
          <tr>
            <td colspan="8" class="no-transactions-message">
              {{ noTransactionsMessage }}
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>

    <div class="pagination-container">
  <button class="pagination-button" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
    <i class="fa-solid fa-chevron-left"></i>
  </button>
  <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
  <button class="pagination-button" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">
    <i class="fa-solid fa-chevron-right"></i>
  </button>
</div>

  </div>
</div>


